"use client";

import { useCallback, useEffect, useState } from "react";
import { KEY_FIELDS_ONLY_STORAGE_KEY } from "@/app/_module/utils/customFieldAliases";

const EVENT = "lead-custom-fields-key-only-change";

/**
 * "Key fields only" (Carrier, Annual Premium, Monthly Premium) vs "show all
 * custom fields" — ONE preference shared by the lead card and the filter /
 * sort pickers, remembered per browser. Default ON. Read in an effect (never
 * the useState initialiser) so the server and client render the same first
 * frame; sibling components stay in sync through a window event.
 */
export function useKeyFieldsOnly(): [boolean, (next: boolean) => void] {
  const [keyOnly, setKeyOnlyState] = useState(true);
  useEffect(() => {
    const read = () => {
      try { setKeyOnlyState(localStorage.getItem(KEY_FIELDS_ONLY_STORAGE_KEY) !== "0"); } catch { /* keep default */ }
    };
    read();
    window.addEventListener(EVENT, read);
    return () => window.removeEventListener(EVENT, read);
  }, []);
  const setKeyOnly = useCallback((next: boolean) => {
    setKeyOnlyState(next);
    try { localStorage.setItem(KEY_FIELDS_ONLY_STORAGE_KEY, next ? "1" : "0"); } catch { /* ignore */ }
    window.dispatchEvent(new Event(EVENT));
  }, []);
  return [keyOnly, setKeyOnly];
}
